import { pathJoin } from './path';
import { qsParse as parseSearchParams, qsStringify as stringifySearchParams } from './qs';
const anchorEl = document.createElement('a');
export const urlParse = (url) => {
    anchorEl.href = url;
    const { protocol, username, password, host, port, hostname, hash, search, pathname: _pathname } = anchorEl;
    // fix: ie 浏览器下，解析出来的 pathname 是没有 / 根的
    const pathname = pathJoin('/', _pathname);
    const auth = username && password ? `${username}:${password}` : '';
    const query = search.replace(/^\?/, '');
    const searchParams = parseSearchParams(query);
    const path = `${pathname}${search}`;
    return {
        protocol,
        auth,
        username,
        password,
        host,
        port,
        hostname,
        hash,
        search,
        searchParams,
        query,
        pathname,
        path,
        href: url
    };
};
export const urlStringify = (url) => {
    const { protocol, auth, host, pathname, searchParams, hash } = url;
    const authorize = auth ? `${auth}@` : '';
    const querystring = stringifySearchParams(searchParams);
    const search = querystring ? `?${querystring}` : '';
    let hashstring = hash.replace(/^#/, '');
    hashstring = hashstring ? '#' + hashstring : '';
    return `${protocol}//${authorize}${host}${pathname}${search}${hashstring}`;
};
export const urlSetParams = (url, setter) => {
    const p = urlParse(url);
    Object.assign(p.searchParams, setter);
    return urlStringify(p);
};
export const urlDelParams = (url, removeKeys) => {
    const p = urlParse(url);
    removeKeys.forEach((key) => delete p.searchParams[key]);
    return urlStringify(p);
};
